import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

function buildResources(context) {
  const resources = {};
  context.keys().forEach((key) => {
    const ns = key.replace('./', '').replace('.json', '');
    resources[ns] = context(key);
  });
  return resources;
}

const enContext = require.context('./locales/en', false, /\.json$/);
const jaContext = require.context('./locales/ja', false, /\.json$/);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: buildResources(enContext),
      ja: buildResources(jaContext),
    },
    fallbackLng: 'en',
    defaultNS: 'common',
    fallbackNS: 'common',
    interpolation: { escapeValue: false },
    detection: {
      // Ignore the old i18nextLng value (often auto-saved as English).
      order: ['localStorage', 'htmlTag'],
      lookupLocalStorage: 'insightpilotLng',
      caches: ['localStorage'],
    },
  });

export default i18n;
